<section
  class="modal-overlay"
  [class.active]="modalIsActive"
  (click)="handleCloseModal()"
></section>
<section class="modal-content" [class.active]="modalIsActive">
  <section class="modal-content-section">
    <h3 class="modal-content-title">{{ title }}</h3>
    <div class="copy-data-block">
      <input
        type="text"
        [id]="inputName"
        [value]="inputValue"
        class="copy-data-block-input"
        [ngStyle]="{
          'height.px': heightInput,
          'font-size.px': fontSize,
          padding: padding
        }"
        readonly
      />
      <button
        type="button"
        class="copy-data-block-button"
        title="Copiar Link de Verificação"
        [ngStyle]="{ 'height.px': heightButton }"
        (click)="handleCopyDataToClipboard()"
      >
        <span class="material-icons copy-data-block-button-icon"
          >content_copy</span
        >
      </button>
    </div>
    <p class="copy-data-block-info-text">{{ infoText }}</p>
    <button
      type="button"
      class="btn btn-primary copy-data-block-close-button"
      data-dismiss="modal"
      (click)="handleCloseModal()"
    >
      OK
    </button>
  </section>
</section>
